import React, { useEffect, useState } from 'react'
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, Label, Input, Button,
  Col, Row, Card,
  Carousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption,
} from 'reactstrap';
import { useCarruselItems } from './useCarruselItems';

const CantidadSelector = ({ value, updateItemsArrayLength }) => {
  return (
    <FormGroup row>
      <Label for="cantidadSelect" sm={4}>Cantidad</Label>
      <Col sm={8} className="mt-auto">
        <Input type="select" name="select" value={value} id="cantidadSelect" onChange={(evt) => updateItemsArrayLength(evt.target.value)}>
          <option value={0}>Sin Imagenes</option>
          <option value={1}>1 Imagen</option>
          <option value={2}>2 Imagenes</option>
          <option value={3}>3 Imagenes</option>
          <option value={4}>4 Imagenes</option>
          <option value={5}>5 Imagenes</option>
        </Input>
      </Col>
    </FormGroup>
  )
}

const PropiedadesCarruselSelector = ({ carruselProperties, setCarruselProperties }) => {
  return (
    <Row>
      <Col>
        <FormGroup row>
          <Label for="WidthSelect" sm={4}>Ancho</Label>
          <Col sm={4} className="mt-auto">
            <Input type="select" name="select" value={carruselProperties.width} id="WidthSelect" onChange={(evt) => setCarruselProperties({ ...carruselProperties, width: evt.target.value })}>
              <option value="75%">75%</option>
              <option value="100%">100%</option>
            </Input>
          </Col>
        </FormGroup>
      </Col>
      <Col>
        <FormGroup row>
          <Label for="heightSelect" sm={4}>Alto</Label>
          <Col sm={4} className="mt-auto">
            <Input type="select" name="select" value={carruselProperties.height} id="heightSelect" onChange={(evt) => setCarruselProperties({ ...carruselProperties, height: evt.target.value })}>
              <option value={"300px"}>300px</option>
              <option value={"400px"}>400px</option>
              <option value={"500px"}>500px</option>
            </Input>
          </Col>
        </FormGroup>
      </Col>
    </Row>
  );
}

const Carrusel = ({ carruselProperties, items }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
        className="text-center"
      >
        <img src={item.Imagen} alt={item.Titulo} width={carruselProperties.width} height={carruselProperties.height} />
        <CarouselCaption captionText={item.Subtitulo} captionHeader={item.Subtitulo} />
      </CarouselItem>
    );
  });

  return (
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
    >
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </Carousel>
  )
}

const CarrouselArray = ({ items, catchAndUpdateImage, updateTitle, updateDescr, updateOrder, removeItem }) => {
  return (
    <Row>
      {
        items.map((item, index) => (
          <Col sm={12} md={4} className="p-1">
            <Card key={"card-" + index} body className="p-0 rounded">
              <label className="cursor-pointer" for={"raised-button-file-" + index} className="m-0">
                <div className="img-modal-novedad">
                  <img className="img-modal-novedad-holder rounded" height={225} width="100%" src={item.Imagen} alt={"Carousel image " + index} />
                </div>
              </label>
              <input type="file" accept="image/*" id={"raised-button-file-" + index} name={"raised-button-file-" + index} className="d-none"
                onChange={evt => {
                  const idx = index;
                  catchAndUpdateImage(idx, evt);
                }}
              />
              <Input type="text" placeholder="Titulo" value={item.Titulo} name="Titulo" id="Titulo" onChange={evt => {
                const idx = index;
                updateTitle(idx, evt.target.value);
              }}
              />
              <Input type="textarea" placeholder="Contenido" value={item.Subtitulo} name="Descripcion" id="Descripcion" onChange={evt => {
                const idx = index;
                updateDescr(idx, evt.target.value);
              }}
              />
              <Row className="my-1 text-center">
                {
                  (index == 0 || index == (items.length - 1)) && <Col />
                }
                {
                  index > 0 && items.length > 1 &&
                  <Col className="px-1">
                    <Button color="success" className="w-75 rounded"
                      onClick={(evt) => {
                        const idx = index;
                        updateOrder(idx, -1);
                      }}
                    ><span className="fa fa-arrow-left" /></Button>
                  </Col>
                }
                {
                  index < (items.length - 1) && items.length > 1 &&
                  <Col className="px-1">
                    <Button color="success" className="w-75 rounded"
                      onClick={(evt) => {
                        const idx = index;
                        updateOrder(idx, +1);
                      }}
                    ><span className="fa fa-arrow-right" /></Button>
                  </Col>
                }
                <Col className="px-1">
                  <Button color="warning" className="w-75 rounded"
                    onClick={(evt) => {
                      const idx = index;
                      removeItem(idx);
                    }}
                  ><span className="fa fa-trash" /></Button>
                </Col>
              </Row>
            </Card>
          </Col>
        ))
      }
    </Row>
  )
}

const CarruselImages = (props) => {

  const [modal, setModal] = useState(false);
  const { nav } = props;

  const toggle = () => setModal(!modal);

  const {
    items,
    setItems,
    updateItemsArrayLength,
    updateTitle,
    updateDescr,
    updateImage,
    updateOrder,
    removeItem,
    getItems,
    saveItems
  } = useCarruselItems();

  const [carruselProperties, setCarruselProperties] = useState({ width: "100%", height: "400" });

  const catchAndUpdateImage = (index, evt) => {
    evt.preventDefault();
    let node = document.getElementById("raised-button-file-" + index);
    if (node && node.files && node.files.length == 1) {
      updateImage(index, node.files[0]);
    };
  }

  useEffect(() => {
    const newItems = [...items];
    newItems.forEach((item) => {
      item.Width = carruselProperties.width;
      item.Height = carruselProperties.height;
    })
    setItems(newItems);
  }, [carruselProperties, items.length])

  useEffect(() => { if (modal) { getItems(); } }, [modal]);

  const saveAndExit = () => {
    const failureItems = () => { };
    const successCallback = () => {
      setItems([]);
      toggle();
    }
    const preprocessItems = (items) => {
      const newItems = [...items];
      newItems.forEach((item) => {
        item.Width = carruselProperties.width;
        item.Height = carruselProperties.height;
      })
      return newItems;
    }
    saveItems(preprocessItems, successCallback, failureItems);
  }

  return (
    <React.Fragment>
      <li className="nav-item cursor-pointer"><a onClick={() => toggle()} className="nav-link" aria-current="page"><i className={nav.icon}></i>{nav.name}</a></li>
      <Modal isOpen={modal} toggle={toggle} className="modal-xl" >
        <ModalHeader toggle={toggle}>Definición de Carrusel</ModalHeader>
        <ModalBody>
          <Row>
            {items.length > 0 && <Col xs={12}>Demostración</Col>}
            <Col xs={12}>
              <Carrusel {...{ carruselProperties, items }} />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={3}>
              <CantidadSelector {...{ updateItemsArrayLength, value: items.length }} />
            </Col>
            <Col xs={8}>
              <PropiedadesCarruselSelector {...{ carruselProperties, setCarruselProperties }} />
            </Col>
            <Col xs={12}>
              <CarrouselArray {...{
                items,
                catchAndUpdateImage,
                updateTitle,
                updateDescr,
                updateOrder,
                removeItem,
              }} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveAndExit} className="rounded">Confirmar</Button>{' '}
          <Button color="secondary" onClick={toggle} className="rounded">Cancelar</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}
export default CarruselImages;


// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/CarruselImages/CarruselImages.js